import { usePut } from '../../../sharedModules/hooks/useQuery';

interface UpdateCollectionClientParams {
  id: number;
  active: boolean;
}

interface UpdateCollectionClientResponse {
  id: number;
  location: string;
  acct_no: string;
  active: boolean;
}

export function useUpdateCollectionClient() {
  const mutation = usePut<UpdateCollectionClientResponse>();

  const updateClient = ({ id, active }: UpdateCollectionClientParams) =>
    mutation.mutateAsync({
      url: `/collections/clients/${id}`,
      data: { client: { active } },
    });

  return {
    updateClient,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
}
